import { Component } from 'js-component-framework';
import 'weather-alerts-tabs.scss';

/**
 * Component for Weather Alerts Page Tabs
 */
export default class WeatherAlertsTabs extends Component {
  /**
   * Start the component
   */
  constructor(config) {
    super(config);

    /**
    * Set up variables
    */
    const {
      navLinks,
      conditionsTab,
      conditionsNav,
    } = this.children;

    function setActiveOnLoad() {
      conditionsTab.classList.add('active');
      conditionsNav.parentElement.classList.add('active');
    }

    function onTabClick(event) {
      event.preventDefault();

      const activeTabs = document.querySelectorAll('.active');

      activeTabs.forEach((tab) => {
        tab.classList.remove('active');
      });

      event.target.parentElement.classList.add('active');

      document.getElementById(event.target.href.split('#')[1]).classList.add('active'); // eslint-disable-line max-len
    }

    navLinks.forEach((link) => {
      link.addEventListener('click', onTabClick, false);
    });

    window.addEventListener('load', setActiveOnLoad);
  }
}
